import React from 'react'
import logo from '../assets/Logo.webp'
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
function Download() {
    return (
        <div className='card-container-download'>
            <div className='card-download'>
                <div className='card-logo'>
                    <img id='logo-dl' src={logo} alt='logo' />
                    <Typography color='white' variant='h2'>Télécharger Battle.net</Typography>
                    <Typography sx={{ color: 'gray' }} variant='h5'>Tous vos jeux blizzard au même endroit.</Typography>
                    <div className='card-button'>
                        <Button className='button-download'>Télécharger</Button>
                        <Button className='button-information-dl'>En savoir plus</Button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Download